/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.users.schedule.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.calendar'
])

.controller('UsersScheduleController', ['$scope', '$state', 'ApiService', 'CalendarService', function($scope, $state, ApiService, CalendarService) {

    $scope.usersSchedule = {

      model: {},
      events: [],

      init: function() {

        console.log('UsersViewEventsController::init', $state.params.id);
        $scope.$on('UsersViewController::userScheduleUpdateSuccess', this.onUserEventsUpdated);
        if ($state.params && $state.params.id) {
          this.getUser($state.params.id);
          this.getEvents($state.params.id);
        }

      },

      getUser: function(id) {
        ApiService.user.view(id).then(this.success.getUser, this.error.getUser);
      },

      getEvents: function(id) {
        var model = {
          ownerId: id,
          startTime: CalendarService.toISO8601(new Date()),
          endTime: CalendarService.toISO8601(new Date().setDate((new Date()).getDate() + 1))
        };
        ApiService.entity.schedules.owner(model).then(this.success.getEvents, this.error.getEvents);
      },

      success: {
        getUser: function(response) {
          var title,
              self = $scope.usersSchedule;
          console.log('UsersViewController::success:getUser', response);
          self.model = response.data.user;

          if (self.model.firstName) {
            title = self.model.firstName;
            if (self.model.lastName) {
              title += ' ' + self.model.lastName;
            }
          }else if (self.model.email) {
            title = self.model.email;
          }else{
            title = 'User Schedule';
          }

          $scope.$emit('Application::contentTitleChange', {
            title: title
          });

        },
        getEvents: function(response) {
          console.log('UsersViewEventsController::success::getEvents', response);
          $scope.usersSchedule.events = response.data.payload;
        }
      },

      error: {
        getUser: function(response) {
          console.log('UsersViewController::error:getUser', response);
        },
        getEvents: function(response) {}
      },

      onUserEventsUpdated: function(e, data) {
        console.log('UsersViewEventsController::onUserEventsUpdated', data);
        $scope.usersSchedule.events = data.events;
      }

    };

    $scope.usersSchedule.init();

}]);